//@ts-check
export const PROFILE_STATUS_ACTIVE = 1;
export const PROFILE_STATUS_BLOCKED = 2;
export const PROFILE_STATUS_PENDING_TO_DELETE = 3;

export const PROFILE_STATUSES = {
	[PROFILE_STATUS_ACTIVE]: 'Active',
	[PROFILE_STATUS_BLOCKED]: 'Blocked'
}

export const PROFILE_TYPE_PERSONAL = 1;
export const PROFILE_TYPE_BUSINESS = 2;

export const PROFILE_TYPES = {
    [PROFILE_TYPE_PERSONAL]: 'Personal',
    [PROFILE_TYPE_BUSINESS]: 'Business',
}

export const PROFILE_TYPES_CLASSES = {
    [PROFILE_TYPE_PERSONAL]: 'badge-info',
    [PROFILE_TYPE_BUSINESS]: 'badge-warning',
}

export default class Profile {
	#profile = null;

	constructor(data = {}) {
		this.#profile = data;
	}

	get id() {
		return this.#profile.id;
	}

	get photo() {
		return this.#profile.photo;
	}

	get name() {
		return this.#profile.name;
	}
}